export { ROLE_USERS_ATTRIBUTE_CLASS_NAME } from "./customization/attributes/RoleUsers/constants";

/**
 * Unikátní klíč rendereru pro GridParticipants template.
 */
export const GRID_PARTICIPANTS_TEMPLATE_RENDERER_KEY = "grid-participants";
/**
 * Unikátní klíč rendereru pro GridParticipants Role user template.
 */
export const GRID_PARTICIPANTS_ROLE_USERS_TEMPLATE_RENDERER_KEY = "grid-participants-role-users";
/**
 * Defaultní hodnota pro zobrazení při prázdném názvu.
 */
export const EMPTY_PARTICIPANT_TEXT_VALUE = "-";
